
import { View, Accordion, Disclosure, DisclosureTitle, DisclosurePanel, Flex, TextField, Heading, Divider, Button, Link, ActionButton, Form, Key } from '@adobe/react-spectrum';
import React, { useEffect, useRef, useState } from 'react';
import { Check, ExclamationTriangle, Plus } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { Item } from "../../../../../services/soap/dataObjects/Item";
import ComponentRelations from '../ComponentRelations';
import ComponentCategoryTable from '../formComponents.tsx/ComponentCategoryTable';

const ProductComponentSection: React.FC<{
    data: Item;
    onChange: (data: Item) => void;
    validationErrors?: any
    expandedSectionKey?: any
    setExpandedSectionKey: (data: any) => void;
    setValidationErrors: (data: any) => void;
    fieldConfig?: any
    validationStatus?: any
    setValidationStatus: (data: any) => void;
    styles?: any;
}> = ({ data = { name: '' }, onChange, validationErrors, expandedSectionKey, setExpandedSectionKey,
    setValidationErrors,
    fieldConfig,
    validationStatus,
    setValidationStatus,
    styles }) => {
        const [isConfirmEnabled, setIsConfirmEnabled] = useState(false);
        const [isSectionRequired, setIsSectionRequired] = useState(false);
        const componentData = Array.isArray(data.COMPONENT)
            ? data.COMPONENT
            : data.COMPONENT
                ? [data.COMPONENT]
                : [];
                const uniqueComponents = Array.from(
                new Map(componentData.map((item:any) => [item.component, item])).values()
              );

        const handleSectionExpandedChange = () => {
            setExpandedSectionKey((prevKey: any) => prevKey.has("componentSection") ? new Set() : new Set(["componentSection"]));
        };

        const { t } = useTranslation('products');
        const _t = (key: string) => t(`addNewProduct.${key}`, { ns: 'products' });
        const _tt = (key: string) => t(`product_common.${key}`, { ns: 'products' });
        return (
            <Accordion expandedKeys={expandedSectionKey} isQuiet
                onExpandedChange={() => handleSectionExpandedChange()}>
                <Disclosure id={"componentSection"}>
                    <DisclosureTitle>
                        <Flex justifyContent="space-between" alignItems="center" width="100%">
                            <View><span>{_t(`productCompnentSection`)}</span><span style={{ color: '#B0BEC5', fontFamily: 'Adobe Clean' }}>{isSectionRequired && ` (${_tt('required')})`}</span></View>
                            {validationStatus.componentSection ? <Check size={20} color="#1976D2" /> : <ExclamationTriangle size={20} color="#FF9800" />}
                        </Flex>
                    </DisclosureTitle>
                    <DisclosurePanel>
                        <Divider size='M' UNSAFE_style={{ marginBottom: 5 }} />
                        <Flex direction={{ base: "column", L: 'column' }} gap="size-100" width="100%">
                            <Flex direction={{ base: "column", L: 'column' }} gap="size-100" width="100%">
                                <ComponentRelations
                                    data={uniqueComponents || []} onChange={onChange} formData={data} expandedSectionKey={expandedSectionKey} />
                            </Flex>
                        </Flex>
                    </DisclosurePanel>
                </Disclosure>
            </Accordion>
        );

    }

export default ProductComponentSection;